import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Input } from "@/components/ui/input";
import { Loader2, Lock } from "lucide-react";
import Logo from "@/components/Logo";

export default function AdminLogin() {
  const { t } = useTranslation();
  const { login } = useAdminAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    const res = await login(email, password);
    setBusy(false);
    if (res.ok) nav("/admin");
    else setErr(res.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream-200 paper-texture px-5">
      <div className="w-full max-w-[420px] bg-cream-50 rounded-3xl shadow-elevated border border-ink-200/40 p-8 animate-fade-up">
        <div className="text-center mb-5">
          <div className="flex justify-center mb-3"><Logo variant="mark" className="w-16 h-16" /></div>
          <h1 className="font-editorial italic text-3xl text-ink-900">{t("admin.login_title")}</h1>
          <p className="text-xs text-ink-500 mt-1">{t("admin.login_hint")}</p>
        </div>
        <form onSubmit={submit} className="flex flex-col gap-3">
          <div>
            <label className="text-[11px] uppercase tracking-[0.16em] font-semibold text-ink-500">{t("admin.email")}</label>
            <Input
              data-testid="admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1 h-11 bg-white border-ink-200/60 focus-visible:ring-corten-400"
              required
            />
          </div>
          <div>
            <label className="text-[11px] uppercase tracking-[0.16em] font-semibold text-ink-500">{t("admin.password")}</label>
            <Input
              data-testid="admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1 h-11 bg-white border-ink-200/60 focus-visible:ring-corten-400"
              required
            />
          </div>
          {err && <p data-testid="admin-login-error" className="text-sm text-red-700">{err}</p>}
          <button
            type="submit"
            disabled={busy}
            data-testid="admin-login-submit"
            className="mt-2 inline-flex items-center justify-center gap-2 h-12 rounded-full bg-corten-400 text-white font-semibold tracking-wide hover:bg-corten-500 disabled:opacity-60 active:scale-[0.98] transition"
          >
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />}
            {t("admin.login_button")}
          </button>
        </form>
      </div>
    </div>
  );
}
